
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getReferralCodeFromUrl, storeReferralCode } from '@/utils/referralUtils';
import { affiliateService } from '@/services/affiliateService';

export const ReferralLinkHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [processed, setProcessed] = useState(false);

  useEffect(() => {
    const handleReferralCode = async () => {
      // Only run this logic once and only on the home page or landing pages, not on the register page itself
      if (!processed && location.pathname !== '/auth/register') {
        const referralCode = getReferralCodeFromUrl();
        
        if (referralCode) {
          console.log(`Detected referral code: ${referralCode}`);
          
          // Store the referral code in cookie
          storeReferralCode(referralCode);
          
          // Record the click in database
          await affiliateService.recordReferralClick(referralCode);
          
          // Mark as processed to prevent duplicate processing
          setProcessed(true);
          
          // Redirect to registration page
          navigate('/auth/register');
        }
      }
    };

    handleReferralCode();
  }, [location, navigate, processed]);

  // This is a utility component that doesn't render anything
  return null;
};

export default ReferralLinkHandler;
